import type { FormikValues } from 'formik';
import { useIntl } from 'react-intl';
import * as Yup from 'yup';

import FormikForm from '../../../../components/Formik/Form/FormikForm.js';
import { regexValidator } from '../../../../helpers/regexValidator.js';

interface EvaluationFormValues {
  osProjectName: string;
}

interface EvaluationFormProps {
  disabled: boolean;
  onSubmit: (values: EvaluationFormValues) => Promise<void>;
}

const EvaluationForm = ({ disabled, onSubmit }: EvaluationFormProps): React.JSX.Element => {
  const intl = useIntl();
  const fields = [
    {
      fieldType: 'text',
      name: 'osProjectName',
      label: intl.formatMessage({ id: 'projectNameField' }),
      disabled,
    },
  ];

  const initialValues = {
    osProjectName: '',
  };

  const validationSchema = Yup.object().shape({
    osProjectName: Yup.string()
      .required(intl.formatMessage({ id: 'formRequiredError' }))
      .matches(regexValidator.noSpace, intl.formatMessage({ id: 'spacesNotAllowed' })),
  });

  return (
    <FormikForm
      fields={fields}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values: FormikValues) => {
        onSubmit(values as EvaluationFormValues).catch((error: unknown) => {
          console.error('Error submitting form:', error);
        });
      }}
      submitLabel={intl.formatMessage({ id: 'submit' })}
    />
  );
};

export default EvaluationForm;
